/* esm.sh - applesauce-signers@5.2.0/signers/amber-clipboard-signer */
export * from "/*applesauce-signers@5.2.0/esnext/signers/amber-clipboard-signer.mjs";
